import FacebookHandlers from "./facebook";
import ArtsAiHandlers from "./artsai";
import ImpactHandlers from "./impact";
import GoogleAdwordsHandlers from "./adwords";
import BingHandlers from "./bing";
import PinterestHandlers from "./pinterest";
import HealthlineHandlers from "./healthline";
import IterableHandlers from "./iterable";
import TiktokHandlers from "./tiktok";
import RedditHandlers from "./reddit";
import RoktHandlers from "./rokt";
import SafeOptHandlers from "./safeopt";
import HorizonHandlers from "./horizon";
import TVSquaredHandlers from "./tvsquared";
import TaboolaHandlers from "./taboola";
import TwitterHandlers from "./twitter";
import YelpHandlers from "./yelp";
import GtmHandlers from "./gtm";
import TraakrHandlers from "./traakr";
import SnapchatHandlers from "./snapchat";
import iSpotHandlers from "./iSpot";

export function initializePublishers() {
  FacebookHandlers();
  PinterestHandlers();
  GoogleAdwordsHandlers();
  BingHandlers();
  ImpactHandlers();
  HealthlineHandlers();
  ArtsAiHandlers();
  IterableHandlers();
  TiktokHandlers();
  RedditHandlers();
  RoktHandlers();
  SafeOptHandlers();
  HorizonHandlers();
  TVSquaredHandlers();
  TaboolaHandlers();
  TwitterHandlers();
  YelpHandlers();
  GtmHandlers();
  TraakrHandlers();
  SnapchatHandlers();
  iSpotHandlers();
}
